import { render, staticRenderFns } from "./ScientificCalculator.vue?vue&type=template&id=22945a59&scoped=true&"
import script from "./ScientificCalculator.vue?vue&type=script&lang=js&"
export * from "./ScientificCalculator.vue?vue&type=script&lang=js&"
import style0 from "./ScientificCalculator.vue?vue&type=style&index=0&id=22945a59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22945a59",
  null
  
)

export default component.exports